import type { SelectionStatePayload } from "../grids/PaginatedApplicationPrimerGrid";
import type { NestedFilterParams } from "../../domain/grid/resultLoader";

// GR-3342 rework: one selection contract for every bulk action.
//
// GR-3341 and GR-3342 each grew their own, and the two disagreed on both the
// id key and how filters travelled. That is not a style difference: the
// server-side refusal logic is written against one shape, so a second shape
// means a second implementation of "can I reproduce what the operator was
// looking at", and the whole point of that logic is that it must never be
// wrong. One shape, one refusal path.

// The server declining to run, as opposed to a report of what it did. Every
// bulk endpoint answers with one or the other.
export interface BulkRefusal {
  errors: string[];
}

export const isRefusal = <T extends object>(result: T | BulkRefusal): result is BulkRefusal =>
  (result as BulkRefusal).errors !== undefined;

// `record_ids`, not a per-resource key: the server reads a selection, and
// which table the rows live in is the endpoint's business, not the payload's.
//
// In "all matching" mode the client holds no ids at all, only the rows the
// operator un-ticked, so the filters have to ride along and the server rebuilds
// the scope the grid was showing.
//
// nestedFilterParams already returns the { f: { column: ... } } hash the server
// parses, so it is SPREAD here, never nested under another key. Wrapping it
// again puts f.f (or filter_params.f) on the wire, GridParams#permit drops it,
// and the action resolves to every row in the organisation while reporting the
// filtered count. bulkArchiveFlow.test.ts and bulkBlockedDateDeleteFlow.test.ts
// pin the shape as each caller puts it on the wire.
export const bulkSelectionPayload = (
  selection: SelectionStatePayload,
  filterParams?: NestedFilterParams
) =>
  selection.mode === "explicit"
    ? { selection_mode: "explicit", record_ids: selection.selectedIds }
    : {
        selection_mode: "all_matching",
        excluded_ids: selection.excludedIds,
        ...(filterParams ?? {}),
      };
